import React from "react";
import { Package, ProductObject } from "types";
import { Loader } from "../../Loader";
import { NoProductsAlert } from "../NoProductsAlert";
import { PackageTile } from "./PackageTile";

interface PackageListProps {
    packages: Package[];
    isLoading: boolean;
    isFiltered: boolean;
}

export const PackageList = ({ packages = [], isLoading, isFiltered }: PackageListProps) => {
    return (
        <div>
            {isLoading ? (
                <Loader size="tiny" className="p-2" text="Loading Packages" />
            ) : (
                <div className="py-15 px-10">
                    {packages.length > 0 || isFiltered ? (
                        <div className="grid grid-cols-2 gap-y-10 gap-x-12">
                            {packages.map((pkg: Package) => (
                                <PackageTile key={pkg.id} pkg={pkg} />
                            ))}
                        </div>
                    ) : (
                        <NoProductsAlert object={ProductObject.PACKAGE} />
                    )}
                </div>
            )}
        </div>
    );
};
